import { useState ,createContext, useLayoutEffect, useEffect } from "react";
import { addWebsiteLog, getCollectionDocs, getPage, getStorageImage, getWebsite, updateData, uploadImage } from "../firebase/firebase_functions";
import { toast } from "react-toastify";

export const AppContext = createContext(null);

// =========================
// Main App context provider
// =========================
export default function AppContextProvider({children}) {

    // Cookies approvment status
    const [cookiesApprooved, setCookiesApprooved] = useState(()=>{
        const ca = localStorage.getItem("webingo_cookiesApprooved");
        return ca ? JSON.parse(ca) : false;
    })
    // Current user object at local storage
    const [currentUser, setCurrentUser] = useState(()=>{
        const user = localStorage.getItem("webingo_currentUser");
        return user ? JSON.parse(user) : null;
    });
    // User connected status
    const [connected, setConnected] = useState(()=>{
        const connection = localStorage.getItem("webingo_connected");
        return connection ? JSON.parse(connection) : false;
    });
    // Manager connected status
    const [connectedManager, setConnectedManager] = useState(()=>{
        const connection = localStorage.getItem("webingo_connectedManager");
        return connection ? JSON.parse(connection) : false;
    });
    // Current website object => main data of website page
    const [currentWebsite, setCurrentWebsite] = useState(()=>{
        const curWeb = localStorage.getItem("webingo_currentWebsite");
        return curWeb ? JSON.parse(curWeb) : null;
    });
    // User UID => basically to differ cart data and url's
    const [currentUserUID, setCurrentUserUID] = useState(()=>{
        const u = localStorage.getItem("webingo_currentUserUID");
        return u ? JSON.parse(u): "";
    });
    // Manager UID => basically to differ url's and dashboard access
    const [currentManagerUID, setCurrentManagerUID] = useState(()=>{
        const u = localStorage.getItem("webingo_currentManagerUID");
        return u ? JSON.parse(u): "";
    });
    // Current manager object at local storage
    const [currentManager, setCurrentManager] = useState(()=>{
        const cm = localStorage.getItem("webingo_currentManager");
        return cm ? JSON.parse(cm) : null;
    });
    // Current user's IP => on website to manage logs
    // Basically for admin usage to manage website activity status
    const [currentIP, setCurrentIP] = useState(()=>{
        const cIP = localStorage.getItem("webingo_currentIP");
        return cIP ? JSON.parse(cIP) : null;
    });
    // Dashboard navigator current page
    // Set it here to have an option of transfer
    // Manager to social editing card from website overlook
    // And to move back manager to "my products" card when delete a product
    const [editPage,setEditPage] = useState(()=>{
        const p = sessionStorage.getItem("webingo_dashboard_page");
        return p ? JSON.parse(p) : 0;
    });
    // At dashboard page => the current card open
    // Set it here to have an option of transfer
    // Manager to social editing card from website overlook
    // And to move back manager to "my products" card when delete a product
    const [currentCard, setCurrentCard] = useState(()=>{
        const c = sessionStorage.getItem("webingo_currentCard");
        return c ? c : null;
    });
    // isBelong =>  A flag that checks if the current user
    // connected is belong to the current website
    // to prevent displaying clients data from websiteX on websiteY
    const [isBelong, setIsBelong] = useState(()=>{
        const isB = localStorage.getItem("webingo_isBelong");
        return isB ? JSON.parse(isB) : false;
    });
    // A state to hold the category selected on website
    const [categoryNow,setCategoryNow] = useState(()=>{
        const cw = localStorage.getItem("webingo_currentWebsite");
        const cn = cw ? JSON.parse(cw)?.settings?.categories[0] : null;
        return cn;
    });

    // Main
    const [websitesNames, setWebsitesNames] = useState([]);
    const [primary_color, setPrimary_color] = useState(null);
    const [secondary_color, setSecondary_color] = useState(null);
    const [accent_color, setAccent_color] = useState(null);
    const [navbarArr, setNavbarArr] = useState([]);
    const [hasCategories, setHasCategories] = useState(false);
    const [hasBranches, setHasBranches] = useState(false);
    const [hasJobs, setHasJobs] = useState(false);
    const [hasHelpdesk, setHasHelpdesk] = useState(false);
    const [hasAbout, setHasAbout] = useState(false);
    const [alertFlag,setAlertFlag] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [reFetchWebsiteFlag, setReFetchWebsiteFlag] = useState(false);
    const [isSearchingWebsite ,setIsSearchingWebsite] = useState();
    const [notFound, setNotFound] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const messagesOptions = {
        ok:"הפעולה בוצעה בהצלחה",
        failed:"הפעולה נכשלה, נסה שוב",
        uploaded:"התמונה הועלתה בהצלחה",
        itemDeleted:"המוצר נמחק בהצלחה",
        wrong:"משהו השתבש. נסה לרענן את הדף",
        aware:"נא וודא שמילאת את כל השדות הדרושים",
        empty:"לא כל השדות מלאים כראוי!",
        reload:"מעדכן שינויים...",
        loginManager:"החיבור בוצע בהצלחה - הינך מועבר לדשבורד הניהול",
        oneInstanceProduct:"לא ניתן להוסיף יותר ממוצר אחד ממוצר זה.",
        outOfStock:"המלאי אזל ממוצר זה, עמכם הסליחה.",
        productDecreamentException:"לא ניתן להוריד מוצר זה מהעגלה מעבר לכמות זו!",
        productIncreamentException:"לא ניתן להוסיף מוצר זה מעבר למלאי הקיים!",
        productAdded:"המוצר נוסף לעגלה בהצלחה",
        emailUpdated:"הודעה לאישור הפעולה נשלחה למייל החדש",
        adminDeleteWebsiteMsg:"המשתמש נמחק בהצלחה מהfirestore, storage ו- auth.",
        adminFailedMsg:"משהו השתבש מומלץ לבדוק את הconsole והקוד",
        pageLoadFailed:"טעינת העמוד נכשלה עקב סיבה לא ידועה, אנא נסה לרענן את הדף.",
    }

    // Image upload states:
    const [fileRef, setFileRef] = useState("");
    const [isCatchImage, setIsCatchImage] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    useLayoutEffect(()=>{
        localStorage.setItem("webingo_cookiesApprooved", JSON.stringify(cookiesApprooved))
    },[cookiesApprooved])
    useLayoutEffect(()=>{
        if(cookiesApprooved){
            localStorage.setItem("webingo_currentUser", JSON.stringify(currentUser));
        }
    },[currentUser, cookiesApprooved])
    useLayoutEffect(()=>{
        localStorage.setItem("webingo_currentWebsite", JSON.stringify(currentWebsite));
        if(!currentWebsite) return;
        setPrimary_color(currentWebsite?.settings?.theme?.primary_color);
        setSecondary_color(currentWebsite?.settings?.theme?.secondary_color);
        setAccent_color(currentWebsite?.settings?.theme?.accent_color);
        setNavbarArr(currentWebsite?.settings?.navbar);
        setHasCategories(currentWebsite?.settings?.navbar[1].include)
        setHasBranches(currentWebsite?.settings?.navbar[2].include)
        setHasJobs(currentWebsite?.settings?.navbar[3].include)
        setHasHelpdesk(currentWebsite?.settings?.navbar[4].include)
        setHasAbout(currentWebsite?.settings?.about?.length>0);    
    },[currentWebsite])
    useLayoutEffect(()=>{
        if(cookiesApprooved){
            localStorage.setItem("webingo_connected", JSON.stringify(connected));
        }
    },[connected, cookiesApprooved])
    useLayoutEffect(()=>{
        if(cookiesApprooved){
            localStorage.setItem("webingo_connectedManager", JSON.stringify(connectedManager));
        }
    },[connectedManager, cookiesApprooved])
    useLayoutEffect(()=>{
        if(cookiesApprooved){
            localStorage.setItem("webingo_currentUserUID", JSON.stringify(currentUserUID));
        }
    },[currentUserUID, cookiesApprooved])
    useLayoutEffect(()=>{
        if(cookiesApprooved){
            localStorage.setItem("webingo_currentManagerUID", JSON.stringify(currentManagerUID));
        }
    },[currentManagerUID, cookiesApprooved])
    useLayoutEffect(()=>{
        if(cookiesApprooved){
            localStorage.setItem("webingo_currentManager", JSON.stringify(currentManager));
        }
    },[currentManager, cookiesApprooved])
    useLayoutEffect(()=>{
        if(cookiesApprooved){
            localStorage.setItem("webingo_isBelong", JSON.stringify(isBelong));
        }
    },[isBelong, cookiesApprooved, currentWebsite])
    useLayoutEffect(()=>{
        if(cookiesApprooved){
            if(!currentWebsite || currentIP === null || currentIP === undefined || currentIP === JSON.parse(localStorage.getItem("webingo_currentIP"))){
                return;
            }
            const addLog=async()=>{
                const res = await addWebsiteLog(currentWebsite, currentIP);
            }
            addLog();
            localStorage.setItem("webingo_currentIP", JSON.stringify(currentIP));
        }
    },[currentIP, cookiesApprooved])

    useEffect(() => {
        const fetchFourNames = async () => {
            try {
                const websites = await getCollectionDocs("websites");
                const names = websites.map(web => web.settings.domain);
                setWebsitesNames(names);
            } catch (err) {
                console.error("Failed to fetch website names:", err);
            }
        };

        fetchFourNames();
    }, []);
    useLayoutEffect(()=>{
        if(cookiesApprooved){
            localStorage.setItem("webingo_categoryNow",JSON.stringify(categoryNow));
        }
    },[categoryNow, cookiesApprooved])
    useEffect(()=>{
        if(!toastMessage || toastMessage === "") return;
        try{
            if(toastMessage === messagesOptions.ok || toastMessage === messagesOptions.uploaded || toastMessage === messagesOptions.reload || toastMessage=== messagesOptions.itemDeleted){
                toast.success(toastMessage);
                const fetchUpdatedWebsite = async()=>{
                    const updatedWebsite = await getWebsite("settings.domain",currentWebsite.settings.domain);
                    setCurrentWebsite(updatedWebsite);
                }
                fetchUpdatedWebsite();
            }
            else if(toastMessage === messagesOptions.loginManager || toastMessage === messagesOptions.productAdded || toastMessage.includes("ברוכים הבאים!") || toastMessage === messagesOptions.adminDeleteWebsiteMsg){
                toast.success(toastMessage);
            }
            else if(toastMessage === messagesOptions.wrong || toastMessage === messagesOptions.adminFailedMsg){
                toast.error(toastMessage);
            }
            else{
                toast.warning(toastMessage);
            }
        } catch(err){
            console.error("Error on toast: ",err);
        } finally{
            setToastMessage("");
        }
    },[toastMessage])
    useEffect(()=>{
        sessionStorage.setItem("webingo_dashboard_page",editPage);
        setCurrentCard(null);
    },[editPage])
    useEffect(()=>{
        sessionStorage.setItem("webingo_currentCard",currentCard);
    },[currentCard])


    // ==================
    // Website's behavior
    // ==================
    // Main function that fetches the website from firebase according to location on url
    const getWebsiteByURL=async(location)=>{
        if(!location || !location.pathname)return;
        const domain = location.pathname.replace("/","").split("/")[0];
        if(!domain || domain === undefined || domain === null)return;
        setIsSearchingWebsite(true);
        try{
            // Get the website by the domain set^
            const res = await getWebsite("settings.domain", domain);
            if(!res || !res.settings || !res.settings.domain){
                setNotFound(true);
                return;
            }

            // Check user belong
            const belongRes = await checkUserBelong(res);
            setIsBelong(belongRes);
            // Setting the current website on local storage
            if(currentWebsite?.id !== res?.id) setCategoryNow(res?.settings?.categories[0]);
            setCurrentWebsite(res);
            // Set the browser tab title
            document.title = res.settings.website_name || "Webingo";
            // Get the user's IP
            await fetch(`https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECTID}.cloudfunctions.net/getIp`)
            .then(res => res.json())
            .then(data => {
                if(!data || !data.ip)return;
                setCurrentIP(data.ip);
            });
            await new Promise(resolve => setTimeout(resolve, 400))
            setIsSearchingWebsite(false);
        } catch(err){
            console.error("Error on fetching website from location URL: ",err)
            setNotFound(true);
        } finally{
            setIsSearchingWebsite(false);
        }
    }
    // Set a search of the current user connected and the current website displayed
    // And checks if the user belong to the website's clients
    // Basically to prevent clients data leak between websites and clients
    const checkUserBelong=async(website)=>{
        if(!currentUser || currentUser===null || currentUser===undefined || !website || website===null || website===undefined) return false;
        try {
            let res = false;
            website?.settings?.clients?.map((client)=>{
                if(client?._id===currentUser?._id){
                    res = true;
                }
                return client;
            })
            return res;
        } catch (error) {
            console.error("Error on check user belong: ",error);
            return false;
        }
    }
    // Fetching image from firebase storage to display it on client side
    const fetchImage=async(website, item, setImgURL)=>{
        try{
            let URL;
            
            let path = null;
            if (!item) {
                // No item → use website logo
                path = website?.settings?.logo;
            } else if (typeof item === "string") {
                // Item is already a path string
                path = item;
            } else if (typeof item === "object" && item?.imgURL) {
                // Item is object with imgURL
                path = item.imgURL;
            } else {
                // Item is object but missing imgURL → fallback to website logo
                path = website?.settings?.logo;
            }

            // Always ensure fallback to default if empty
            URL = await getStorageImage(path, website);
            setImgURL(URL);
        }
        catch(err){
            console.error("couldnt fetch logo image: ", err)
        }
    }
    // Handle change image when attempt to upload image to storage
    const handleChangeImage = async(e)=>{
        setIsCatchImage(true);
        try{
            await new Promise(resolve => setTimeout(resolve, 1000));
            setFileRef(e.target.files[0])
        }
        catch(err){
            console.error("Error on change image at FormAddImage component: ",err);
            setIsCatchImage(false);
            setFileRef("")
        }
        finally{
            setIsCatchImage(false);
        }
    }
    // Handle the image upload to storage
    const handleUploadImage= async(_required, website, directory, dynamicPath, isArray, arrayIndex, arrayField, toUpdateDoc, action, uniqueAction, uniqueData, inputResetAction)=>{
        setIsUploading(true);
        try{
            if(_required && fileRef.length===0){
                setToastMessage("נא לבחור קובץ!");
                return;
            }
            if(fileRef !== null && fileRef !== ""){
                const res = await uploadImage(website.id, directory, dynamicPath, fileRef, isArray, arrayIndex, arrayField, toUpdateDoc);
                if(!res.toChange){
                    setToastMessage("התמונה כבר קיימת");
                    return;
                }
                if(action !== null){
                    await action(website, res.path, setToastMessage, messagesOptions);
                }
                if(action === null && uniqueAction !== null){
                    await uniqueAction.update(uniqueData.a, uniqueData.b, uniqueData.c, uniqueData.d, res.path, uniqueData.f, uniqueData.g);
                    uniqueAction.setFlag(false);
                }
                setToastMessage(messagesOptions.uploaded);
            }
            else{
                await action(website, null, setToastMessage, messagesOptions);
            }
            if(inputResetAction){
                inputResetAction();
            }
        } catch(err){
            console.error("Error on attempt to upload image at the FormAddImage component: ",err);
            setIsUploading(false);
        } finally{
            setIsUploading(false);
            setFileRef("");
        }
    }

    // =============================
    // time getters and calculations
    // =============================
    // Formatting a value to a vaild Date object
    // Can get => Date instance/number/string/firebase timestamp/object
    function toDate(value) {
        if (!value && value !== 0) return null;

        // already a Date
        if (value instanceof Date) return value;

        // number (milliseconds since epoch)
        if (typeof value === "number") return new Date(value);

        // ISO string or other parsable string
        if (typeof value === "string") {
            const d = new Date(value);
            return isNaN(d.getTime()) ? null : d;
        }

        // Firebase Timestamp (v9+): has .toDate()
        if (value && typeof value.toDate === "function") {
            return value.toDate();
        }

        // Plain object from some APIs: { seconds, nanoseconds }
        if (typeof value === "object" && typeof value.seconds === "number") {
            const ms = value.seconds * 1000 + Math.floor((value.nanoseconds || 0) / 1e6);
            return new Date(ms);
        }

        return null;
    }
    // Get an input, formatting to Date with toDate function, then format as dd/mm/yyyy
    function formatDate(input) {
        if (input == null) return "Invalid Date";
        const date = toDate(input);
        const dd = String(date.getDate()).padStart(2, "0");
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const yyyy = date.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
    }
    // Calculate days passed from a timestamp till today
    const calculateDaysPassed = (createdAt) => {
        const createdDate = toDate(createdAt);
        if (!createdDate) return null;

        const now = new Date();
        const diffMs = Math.abs(now.getTime() - createdDate.getTime());
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24)); // convert ms -> days
        return diffDays;
    };
    // Calculate today's date
    const getTodayDate = () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        const _date = `${yyyy}-${mm}-${dd}`;
        return _date;
    };

    // =============
    // Branches page
    // =============
    // Click on location/city opens a google search of location
    const openInGoogleMaps = (locationString) => {
        if (!locationString) return;
        // 1. Logical Check (Regex) => checks for the form: 
        // הנביאים 23, תל אביב 
        const addressPattern = /^[\u0590-\u05FF\s'"]+\s\d+,\s?[\u0590-\u05FF\s'"]+$/;
        const isValid = addressPattern.test(locationString.trim());
        if (!isValid) {
            console.warn("Invalid address format. Expected: 'Street Number, City'");
            setToastMessage(messagesOptions.failed);
            return;
        }
        // 2. If valid, proceed to open Google Maps
        const encodedLocation = encodeURIComponent(locationString);
        const url = `https://www.google.com/maps/search/?api=1&query=${encodedLocation}`;
        window.open(url, '_blank');
    };

    // =============
    // Navbar social 
    // =============
    const moveToEditNavBtns = async()=>{
        window.scrollTo({
        top:0,
        behavior:"smooth"
        });
        await new Promise(resolve => setTimeout(resolve, 200));
        setEditPage(1);
        await new Promise(resolve => setTimeout(resolve, 200));
        setCurrentCard("dashboardCard_social");
    }

    // ==========================================
    // Dashboard change website's activity status
    // ==========================================
    const handleChangeActivity = async()=>{
        try {
            const res = await updateData(currentWebsite.id, "settings.isActive", !currentWebsite?.settings?.isActive, false);
            if(!res){
            setToastMessage(messagesOptions.failed);
            return;
            }
            else{
            setToastMessage(messagesOptions.ok);
            }
        } catch (error) {
            console.error("Error on change website activity",error)
            setToastMessage(messagesOptions.wrong);
        }
    }

    // ==============
    // manager logout
    // ==============
    // Logging out the manager from dashboard
    const logout = (nav)=>{
        setConnectedManager(false);
        setCurrentWebsite({});
        nav("/webingo/signin");
    }


    const val ={
        
        // Main:
        cookiesApprooved,
        setCookiesApprooved,
        alertFlag,
        setAlertFlag,
        primary_color,
        secondary_color,
        accent_color,
        navbarArr,
        hasCategories,
        hasBranches,
        hasJobs,
        hasHelpdesk,
        hasAbout,
        toastMessage,
        setToastMessage,
        messagesOptions,

        // Website search:
        isLoading,
        setIsLoading,
        isSearchingWebsite,
        notFound,
        getWebsiteByURL,
        currentWebsite,
        setCurrentWebsite,
        currentUserUID,
        setCurrentUserUID,
        currentManagerUID,
        setCurrentManagerUID,
        reFetchWebsiteFlag,
        setReFetchWebsiteFlag,
        isBelong,
        
        // Landing page:
        websitesNames,
        
        // Images:
        fetchImage,
        handleChangeImage,
        handleUploadImage,
        fileRef,
        setFileRef,
        isCatchImage,
        setIsCatchImage,
        isUploading,
        setIsUploading,

        // Sign in/up:
        connected,
        setConnected,
        connectedManager,
        setConnectedManager,
        currentUser,
        setCurrentUser,
        currentManager,
        setCurrentManager,
        logout,

        // Dashboard
        setEditPage,
        editPage,
        setCurrentCard,
        currentCard,
        handleChangeActivity,

        // Category page:
        setCategoryNow,
        categoryNow,

        // Branches page:
        openInGoogleMaps,

        // Navbar:
        moveToEditNavBtns,

        // Helpers:
        calculateDaysPassed,
        formatDate,
        getTodayDate,
    }

    return (
        <AppContext.Provider value={val}>
            {children}
        </AppContext.Provider>
    )
}
